"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: your name
 * @Date: 2021-12-29 14:35:52
 * @LastEditTime: 2021-12-29 14:47:32
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\render\Radar.ts
 */
exports.default = {
    symbol: "circle",
    itemStyle: {
        normal: {
            areaStyle: { type: "default" }
        }
    },
    data: [
        {
            symbol: "circle",
            symbolSize: 5,
            areaStyle: { color: "rgba(64, 205, 241, 0.2)" },
            itemStyle: {
                normal: {
                    borderWidth: 1,
                    color: "RGBA(0, 34, 66, 1)",
                    borderColor: "rgba(146, 225, 255, 1)"
                }
            },
            lineStyle: {
                color: "rgba(146, 225, 255, 1)",
                width: 1
            }
        }
    ]
};
//# sourceMappingURL=Radar.js.map